import { useState } from 'react';
import { Button } from '@practium/ui';
import styles from './RegionMap.module.css';
import { BrazilMapGL } from '../BrazilMap/BrazilMapGL';
import { MapExpandModal } from './MapExpandModal';
import { hasMapboxToken } from '../../../utils/mapboxUtils';
import type { RegionDTO } from '../../../types/parameters.types';

interface RegionMapProps {
	region: RegionDTO;
}

export const RegionMap = ({ region }: RegionMapProps) => {
	const [isExpanded, setIsExpanded] = useState(false);

	if (!hasMapboxToken()) return null;

	const createdDate = new Date(region.createdAt).toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	});

	return (
		<>
			<div className={styles.card}>
				<div className={styles.header}>
					<div className={styles.titleGroup}>
						<span className={styles.title}>Mapa da Região</span>
						<span className={styles.subtitle}>Criado em {createdDate}</span>
					</div>
					<Button
						variant="secondary"
						className={styles.expandBtn}
						onClick={() => setIsExpanded(true)}
					>
						Expandir
					</Button>
				</div>

				<div className={styles.mapContainer}>
					<BrazilMapGL selectedStateCodes={region.stateCodes} />
				</div>
			</div>

			{isExpanded && (
				<MapExpandModal region={region} onClose={() => setIsExpanded(false)} />
			)}
		</>
	);
};
